import type { BrowseDataAPIFilterOption } from 'src/services/browse-data-api/types/BrowseDataAPIFilter';

export const getActiveFilterCountString = (count: BrowseDataAPIFilterOption['activeCount']) => {
  if (count === null) {
    return '';
  }

  return `(${count > 999 ? '999+' : count})`;
};
